module.exports = __webpack_public_path__ + "static/media/note.a63a73f1.svg";